import { Controller } from "stimulus";

const CLASS_ACCORDION_ACTIVE = 'is-accordion-active';

export default class extends Controller {
    opened = false;

    toggle() {
        if (this.opened) this.close();
        else this.open();
    }

    open() {
        if (this.opened) return;
        this.opened = true;
        this.element.classList.add(CLASS_ACCORDION_ACTIVE);
    }

    close() {
        if (!this.opened) return;
        this.opened = false;
        this.element.classList.remove(CLASS_ACCORDION_ACTIVE);
    }
}


// WEBPACK FOOTER //
// ./public/assets/scripts/controllers/accordion_controller.js